import { post } from '@/request';

const signApi = {
  ipadIndex(data) {
    return post('/nfm/sign/zlb/ipadIndex', data);
  },
  save(data) {
    return post('/nfm/sign/zlb/save', data);
  },
  insert(query) {
    return post('/nfm/sign/zlb/insert', query);
  },
  list(data) {
    return post('/nfm/sign/zlb/list', data);
  },
  info(data) {
    return post('/nfm/sign/zlb/one', data);
  }
};
export default signApi;
